import { saveClicked, saveVisited } from './links.js'

document.addEventListener('DOMContentLoaded', () => {
  saveClicked()
  saveVisited()
  setCharaRandom()

  new Zooming({
    bgColor: "rgb(0, 0, 0)",
    bgOpacity: 0.85,
    customSize: '50%',
    onOpen: (e) => {
      e.previousElementSibling.classList.add('hide')
      e.classList.add('action')
    },
    onClose: (e) => {
      e.previousElementSibling.classList.remove('hide')
      e.classList.remove('action')
    }
  }).listen('.zoom');

  if(window.matchMedia('(max-width: 768px)').matches){
    const uwb = new UWB({
      toolSmoothScroll: {
        init: true,
        offsetSelector: '.main_header',
      },
    });
  } else {
    const uwb = new UWB({
      uaTabletViewport: {
        init: true,
        width: 1140,
      },
    });
  }
  
  UWX.MenuActivate('.index_title', '.index_list');

  UWG.Target('.index_list').GsapSet('actived', {
    height: 'auto',
    y: 0,
  })
  UWG.Target('.index_list').GsapTo('actived', {
    height: 0,
    y: document.querySelector('.index_title').getClientRects().height,
  })
});


const rightCharas = [
  'rc_01', 'rc_02', 'rc_03', 'rc_04', 'rc_05', 'rc_06', 'rc_07',
  'rc_08', 'rc_09', 'rc_10', 'rc_11', 'rc_12', 'rc_13', 'rc_14' 
]
const leftCharas = [
  'lc_01', 'lc_02', 'lc_03', 'lc_04', 'lc_05', 'lc_06', 'lc_07',
  'lc_08', 'lc_09', 'lc_10', 'lc_11', 'lc_12', 'lc_13', 'lc_14' 
]
const setCharaRandom = () => {
  let rightTargets = [...rightCharas]
  let leftTargets = [...leftCharas]
  const startRandom = Math.floor(Math.random() * 2) === 0

  Array.from(document.querySelectorAll('.cs-heading.chara')).forEach((charaElm, i) => {
    for(let key of charaElm.classList.values()){
      if(key.startsWith('lc_') || key.startsWith('rc_')){
        charaElm.classList.remove(key)
      }
    }

    if(startRandom === (i % 2 === 0)){
      const index = Math.floor(Math.random() * rightTargets.length)
      const chara = rightTargets[index]
      rightTargets = rightTargets.filter(t => t !== chara)
      charaElm.classList.add(chara)
    }else{
      const index = Math.floor(Math.random() * leftTargets.length)
      const chara = leftTargets[index]
      leftTargets = leftTargets.filter(t => t !== chara)
      charaElm.classList.add(chara)
    }

  })

}
